import React, { FC } from 'react';
import { EditProjectModalsProps } from './EditProjectModalsProps';
import EditNewProjectModal from '../../containers/EditNewProjectModal';
import EditImproveProjectModal from '../../containers/EditImproveProjectModal';
import EditFormatChangeProjectModal from '../../containers/EditFormatChangeProjectModal';
import EditCloseProjectModal from '../../containers/EditCloseProjectModal';
import EditRelocationProjectModal from '../../containers/EditRelocationProjectModal';

const EditProjectModals: FC<EditProjectModalsProps> = ({
  closeHandler,
  establishmentType,
  project,
  projectsList,
  countries,
  setActiveProject,
  disableRestrictions,
  additionalAction,
  readonly,
  submitTrigger,
  directiveOpen,
}) => {
  return (
    <>
      <EditNewProjectModal
        closeHandler={closeHandler}
        establishmentType={establishmentType}
        project={project}
        projectsList={projectsList}
        countries={countries}
        disableRestrictions={disableRestrictions}
        setActiveProject={setActiveProject}
        additionalAction={additionalAction}
        readonly={readonly}
        submitTrigger={submitTrigger}
        directiveOpen={directiveOpen}
      />
      <EditImproveProjectModal
        closeHandler={closeHandler}
        establishmentType={establishmentType}
        project={project}
        projectsList={projectsList}
        countries={countries}
        setActiveProject={setActiveProject}
        disableRestrictions={disableRestrictions}
        additionalAction={additionalAction}
        readonly={readonly}
        submitTrigger={submitTrigger}
        directiveOpen={directiveOpen}
      />
      <EditFormatChangeProjectModal
        closeHandler={closeHandler}
        establishmentType={establishmentType}
        project={project}
        projectsList={projectsList}
        countries={countries}
        setActiveProject={setActiveProject}
        disableRestrictions={disableRestrictions}
        additionalAction={additionalAction}
        readonly={readonly}
        submitTrigger={submitTrigger}
        directiveOpen={directiveOpen}
      />
      <EditCloseProjectModal
        closeHandler={closeHandler}
        establishmentType={establishmentType}
        project={project}
        projectsList={projectsList}
        countries={countries}
        setActiveProject={setActiveProject}
        disableRestrictions={disableRestrictions}
        additionalAction={additionalAction}
        readonly={readonly}
        submitTrigger={submitTrigger}
        directiveOpen={directiveOpen}
      />
      <EditRelocationProjectModal
        closeHandler={closeHandler}
        establishmentType={establishmentType}
        project={project}
        projectsList={projectsList}
        countries={countries}
        setActiveProject={setActiveProject}
        disableRestrictions={disableRestrictions}
        additionalAction={additionalAction}
        readonly={readonly}
        submitTrigger={submitTrigger}
        directiveOpen={directiveOpen}
      />
    </>
  );
};

export default EditProjectModals;
